import isEmail from 'validator/lib/isEmail';
import isDate from 'validator/lib/isDate';
import rulesConfig from 'config/formRules';

const getRules = ({ items, watch }) => {
    let rules;
    items.map((r) => {
        let label;
        let value;

        switch (r) {
            case 'email':
                label = 'validate';
                value = (input) => isEmail(input) || rulesConfig[r].message;
                break;
            case 'date':
                label = 'validate';
                value = (input) => isDate(input) || rulesConfig[r].message;
                break;
            case 'validate':
                let pwd = watch('password');
                label = r;
                value = (retypedValue) => retypedValue === pwd || rulesConfig[r].message;
                break;
            default:
                label = r;
                value = { ...rulesConfig[r] };
                break;
        }
        rules = {
            ...rules,
            [label]: value,
        };

        return rules;
    });

    return rules;
};

export default getRules;
